module.exports = __webpack_public_path__ + "static/media/upload.4680ce3c.svg";